import { GetAllSegmentsResponseType } from 'features/BannerAndTicker/sevices/banner'
import { PostPutBannerComponentPayloadType, TargetingFormType } from 'redux/dynamicLanding'
import { TargetingResponseType } from 'utils/apiList/dynamicLanding'

export const composeTargetingPayload = (formData: TargetingFormType) => {
  const { targetingType, targetedUsers, targetedSegments } = formData
  const payload: Pick<
    PostPutBannerComponentPayloadType,
    'targeting_type' | 'targeted_user_ids' | 'targeted_segmentations'
  > = {
    targeted_user_ids: [],
    targeted_segmentations: [],
  }

  if (targetingType) {
    payload.targeting_type = targetingType.id
    if (/segment user/i.test(targetingType.details || '')) {
      payload.targeted_user_ids = []
      payload.targeted_segmentations = targetedSegments.map((segment) => ({
        type_id: targetingType?.id as number,
        segment_type_id: segment.id,
      }))
    }

    if (/targeted user/i.test(targetingType.details || '')) {
      payload.targeted_segmentations = []
      payload.targeted_user_ids = targetedUsers.map((user) => user.customer_id)
    }
  }

  return payload
}

export const composeTargetingFormFeed = <T extends TargetingResponseType>(
  constants: StoreStateType['dynamicLanding']['constants'],
  responseData: T,
): TargetingFormType => {
  const { targeted_users, targeting_type, targeted_segmentations } = responseData

  const targetingType = constants.targetingTypes.find((type) => type.id === targeting_type) || null

  const targetingForm: TargetingFormType = {
    targetingType,
    targetedUsers: [],
    targetedSegments: [],
  }

  if (/segment user/i.test(targetingType?.details || '')) {
    targetingForm.targetedSegments = targeted_segmentations.reduce<GetAllSegmentsResponseType>(
      (acc, seg) => {
        const findSegment =
          constants.targetedSegments.find((s) => s.id === seg.segment_type_id) || null

        return findSegment
          ? [
              ...acc,
              {
                name: findSegment.name,
                id: seg.segment_type_id,
                total_user: findSegment.total_user,
              },
            ]
          : acc
      },
      [],
    )
  }

  if (/targeted user/i.test(targetingType?.details || '')) {
    targetingForm.targetedUsers =
      targeted_users?.map((user) => ({
        customer_id: user.user_id,
        customer_phone_number: user.phone,
        customer_name: user.user_name,
      })) || []
  }

  return targetingForm
}
